import { render, staticRenderFns } from "./accept-product.vue?vue&type=template&id=82feac3e"
import script from "./accept-product.vue?vue&type=script&lang=js"
export * from "./accept-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports